export default "__VITE_ASSET__DMpIPW_w__"